/**
 * Auto-download files from url
 * @param {string} uri resource to download
 * @param {string} mime mime type of the resource
 * @param {string} name name of the resource
 */
export function downloadURI(uri, mime, name) {
  var anchor = document.createElement('a')
  document.body.appendChild(anchor)
  anchor.style.display = 'none'

  anchor.setAttribute('href', uri)
  if (mime) anchor.setAttribute('type', mime)
  if (name) anchor.setAttribute('download', name)
  anchor.click()

  document.body.removeChild(anchor)
}
/**
 * returns extension on filename
 * @param {string} filename 
 * @returns string with extension
 */
export function getExtension(filename='') {
  return `.${filename.split(".").pop()}`;
}

/**
 * 
 * @param {string} filename name of the file
 * @param {string} replaceWith character to replace matches with, defaults to '-'
 * @returns string replaced with character provided
 */
export function sanitizeFilename(filename = '', replaceWith = '_') {
  return filename.replace(/[^\w\s.]/g, replaceWith)
}

/**
 * Gets a file name from url or path
 * @param {string} path url path
 * @returns filename
 */
export function getFilenameFromPath(path = '') {
  return path.substring(path.lastIndexOf('/')+1)
}